import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeAlert } from '../../Redux/actions/alert';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import _ from 'lodash';

const StyledAlert = (props) => {
  return <MuiAlert style={{ marginTop: '10px' }} elevation={6} variant="filled" {...props} />;
};

const Alert = () => {
  const dispatch = useDispatch();
  const alerts = useSelector((state) => state.alerts);
  const onCloseAlert = (id) => {
    dispatch(removeAlert(id));
  };

  React.useEffect(() => {
    if (alerts && alerts.length < 1) return;
    var debounce_fun = _.debounce(() => {
      dispatch(removeAlert(alerts[alerts.length - 1].id));
    }, 5000);
    debounce_fun();
    return () => {
      debounce_fun = null;
    };
  }, [alerts, dispatch]);

  return (
    <React.Fragment>
      {alerts && alerts.length > 0 && (
        <Snackbar
          style={{ display: 'block' }}
          open={true}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <>
            {alerts &&
              alerts.length > 0 &&
              alerts.map((alert, i) => (
                <StyledAlert
                  onClose={() => onCloseAlert(alert.id)}
                  key={alert.id}
                  severity={alert.type}
                  id={alert.id}
                >
                  {alert.msg}
                </StyledAlert>
              ))}
          </>
        </Snackbar>
      )}
    </React.Fragment>
  );
};

export default Alert;
